import { c as _c } from "react/compiler-runtime";
import { useDeferredValue, useMemo } from 'react';
import { useAtomValue } from 'jotai';
import parseJson from 'commons/parseJson';
import { getUserLocationWithLongKeys } from 'commons/location';
import userLocationAtom from './userLocationAtom';
const DEfAULT_USER_LOCATION = {};
const useUserLocation = () => {
  const $ = _c(4);
  const shortLocationStringified = useDeferredValue(useAtomValue(userLocationAtom));
  let t0;
  bb0: {
    if (!shortLocationStringified) {
      t0 = undefined;
      break bb0;
    }
    let t1;
    if ($[0] !== shortLocationStringified) {
      t1 = parseJson(shortLocationStringified, DEfAULT_USER_LOCATION);
      $[0] = shortLocationStringified;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    t0 = t1;
  }
  const shortLocation = t0;
  let t1;
  bb1: {
    if (!shortLocation) {
      t1 = DEfAULT_USER_LOCATION;
      break bb1;
    }
    let t2;
    if ($[2] !== shortLocation) {
      t2 = getUserLocationWithLongKeys(shortLocation);
      $[2] = shortLocation;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t1 = t2;
  }
  const userLocation = t1;
  return userLocation;
};
export default useUserLocation;